import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import Rutas from 'src/app/Models/Base/rutas';
import Storage from 'src/app/Models/Base/storage';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { deleteAllCookies, getLocalStorage } from 'npx-arc-ui/utils';

@Component({
  selector: 'app-login-externo',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="login-externo-error" *ngIf="mostrarError">
      <div class="error-contenedor">
        <img src="assets/media/logos/rechazado.png" alt="Rechazado" class="error-icono" />
        <p class="error-mensaje">{{ mensajeError }}</p>
      </div>
    </div>
  `,
  styles: [`
    .login-externo-error {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      width: 100%;
      background-color: #f5f5f5;
    }
    .error-contenedor {
      text-align: center;
      padding: 32px 48px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .error-icono {
      width: 64px;
      height: 64px;
      object-fit: contain;
    }
    .error-mensaje {
      margin-top: 16px;
      font-size: 16px;
      color: #333;
      font-family: 'Roboto', sans-serif;
    }
  `],
})
export class LoginExternoComponent implements OnInit {
  mostrarError = false;
  mensajeError = 'Ocurrió un problema durante el inicio de sesión. Redirigiendo a la aplicación de origen...';

  constructor(
    private route: ActivatedRoute,
    public appStateService: AppStateService
  ) { }

  ngOnInit(): void {
    const
      _email = this.route.snapshot.paramMap.get('email'),
      _pass = this.route.snapshot.paramMap.get('pass'),
      _id_prod = this.route.snapshot.paramMap.get('id_prod');

    if (!!_email && !!_pass) {
      const
        email: string = atob(_email) || '',
        password: string = atob(_pass) || '',
        emailLogeado = getLocalStorage(Storage.EMAIL)?.data || '',
        token = getLocalStorage(Storage.TOKEN)?.data || '';
      var id_prod = '';
      if (_id_prod != null) {
        id_prod = _id_prod;
      }
      this.appStateService.loginValues = {
        email,
        password,
        id_prod
      };
      if (emailLogeado === email && token) {
        this.appStateService.router.navigateByUrl(Rutas.DASHBOARD);
      } else {
        localStorage.clear();
        deleteAllCookies();

        // setTimeout evita el error NG0100 (ExpressionChangedAfterItHasBeenCheckedError)
        setTimeout(() => {
          this.appStateService.onLogin(
            this.appStateService.loginValues, true
          )?.catch(() => {
            this.mostrarErrorYRedirigir();
          });
        });
      }
    } else {
      this.mostrarErrorYRedirigir();
    }
  }

  private mostrarErrorYRedirigir(): void {
    this.mostrarError = true;
    setTimeout(() => {
      // 1. Si la app externa envió un parámetro de retorno (returnUrl o redirect)
      const returnUrl = this.route.snapshot.queryParams['returnUrl'] || this.route.snapshot.queryParams['redirect'];
      if (returnUrl) {
        window.location.href = returnUrl;
        return;
      }

      // 2. Si se abrió en una ventana o pestaña emergente desde la app externa
      if (window.opener && !window.opener.closed) {
        window.close();
        return;
      }

      // 3. Si hay referrer externo (dominio distinto al actual)
      const referrer = document.referrer;
      const currentHost = window.location.host;
      if (referrer && !referrer.includes(currentHost)) {
        window.location.href = referrer;
        return;
      }

      // 4. Si viene de una navegación previa en el historial del navegador
      if (window.history.length > 1) {
        window.history.back();
        return;
      }

      // 5. Si existe referrer (mismo dominio o general)
      if (referrer) {
        window.location.href = referrer;
        return;
      }

      // 6. Fallback final si no hay historial ni origen detectable
      this.appStateService.router.navigateByUrl(Rutas.LOGIN);
    }, 3000);
  }
}
